export default function B2BLogos() {
  return (
    <div className='bg-gray-900 py-24 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='-mx-6 grid grid-cols-2 gap-0.5 overflow-hidden sm:mx-0 sm:rounded-2xl md:grid-cols-3'>
          <div className='bg-white/5 p-8 sm:p-10'>
            <img
              className='max-h-12 w-full object-contain'
              src='/images/b2b/Logos_b2b/-1730833534.png'
              alt='Transistor'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/EH_logo_H.png'
              alt='Reform'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-12 w-full object-contain'
              src='/images/b2b/Logos_b2b/0004970_mainlogo.png'
              alt='Tuple'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='w-full object-contain'
              src='/images/b2b/Logos_b2b/helmetking.avif'
              alt='Laravel'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/footer-logo_11_orig.png'
              alt='SavvyCal'
              width={158}
              height={48}
            />
          </div>

          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-14 w-full object-contain'
              src='/images/b2b/Logos_b2b/E-HAAPPY.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-12 w-full object-contain'
              src='/images/b2b/Logos_b2b/ifaacademy-white-for-web.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/header-logo-right2.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/The-Perspicacity-Group-Logo-trans.webp'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/lofcorporatelogo.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/logo_Northbridge-web.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/stalport.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/logo-com-r-novo-03.webp'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/logo-mdxmedia.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>

          <div className='bg-white/5 p-6 sm:p-10 flex justify-center'>
            <img
              className='max-h-20 object-contain'
              src='/images/b2b/Logos_b2b/logo-white-1.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-14 w-full object-contain'
              src='/images/b2b/Logos_b2b/MM_NEW_LOGO_white.avif'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/NGT-New-logo.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>

          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/ppc-profit-pros-white-tight-768x184.webp'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/RWB-Group-UK-Logo-White-Avada-2-800x103.webp'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-12 w-full object-contain'
              src='/images/b2b/Logos_b2b/svgviewer-png-output (2).png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
          <div className='bg-white/5 p-6 sm:p-10'>
            <img
              className='max-h-16 w-full object-contain'
              src='/images/b2b/Logos_b2b/Denis.png'
              alt='Statamic'
              width={158}
              height={48}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
